import { type ReactNode } from 'react';
import { cn } from '../../lib/cn';

// Пустое состояние. Пустая таблица и слово «Загрузка…» сообщают человеку, что что-то не так,
// хотя чаще всего всё в порядке - просто делать нечего. Поэтому у состояния есть тон:
//
//   good  - «всё хорошо, работы нет»: зелёный кружок, спокойная формулировка
//   muted - «здесь пока пусто»: серый кружок и подсказка, как это заполнить
//
// Приём из прототипа (prototypes/ux): вместо пустой очереди - строка «агент справляется сам».

export function EmptyState({
  icon,
  title,
  description,
  action,
  tone = 'muted',
  className,
}: {
  icon?: ReactNode;
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  tone?: 'good' | 'muted';
  className?: string;
}) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-2 px-7 py-10 text-center', className)}>
      {icon ? (
        <span
          className={cn(
            'mb-1 grid size-11 place-items-center rounded-full text-xl',
            tone === 'good' ? 'bg-green/10 text-green' : 'bg-panel2 text-muted',
          )}
        >
          {icon}
        </span>
      ) : null}
      <div className="font-semibold">{title}</div>
      {description ? (
        <div className="max-w-[34ch] text-sm leading-snug text-muted">{description}</div>
      ) : null}
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
